import {useEffect} from "react"
import { useTheme } from "@mui/material/styles";
import { Avatar, Box, Typography, Button } from "@mui/material";

// project imports
import LogoSection from "../LogoSection";
import SearchSection from "./SearchSection";
import MobileSection from "./MobileSection";
import ProfileSection from "./ProfileSection";
import LocalizationSection from "./LocalizationSection";
import { getLabelsName } from 'store/slices/labelAction'
import NotificationSection from "./NotificationSection";
import { useDispatch, useSelector } from "store";
import { openDrawer } from "store/slices/menu";
import { connect } from "react-redux";
import { store } from 'store'
import { IconMenu2 } from "@tabler/icons";
import Group232 from "../../../assets/Group 232.svg";
import { Link } from "react-router-dom";
// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = (props) => {
  const theme = useTheme();
  const { ownerLabelsName } = props.label;
  const dispatch = useDispatch();
  const { drawerOpen } = useSelector((state) => state.menu);
  const ownerInfo = useSelector((state) => state.auth);

  const fullName = ownerInfo?.admin?.full_name;


  useEffect(()=>{
   if(!ownerLabelsName || ownerLabelsName.length === 0){
     store.dispatch(getLabelsName())
   }
  },[ownerLabelsName])

  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 228,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
        }}
      >
        <Box
          component="span"
          sx={{ display: { xs: "none", md: "block" }, flexGrow: 1 }}
        >
          {/* <Typography variant="h2">Leigulistinn</Typography> */}
          <LogoSection />
        </Box>
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            overflow: "hidden",
            transition: "all .2s ease-in-out",
            background:
              theme.palette.mode === "dark"
                ? theme.palette.dark.main
                : theme.palette.secondary.light,
            color:
              theme.palette.mode === "dark"
                ? theme.palette.secondary.main
                : theme.palette.secondary.dark,
            "&:hover": {
              background:
                theme.palette.mode === "dark"
                  ? theme.palette.secondary.main
                  : theme.palette.secondary.dark,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.secondary.light
                  : theme.palette.secondary.light,
            },
          }}
          onClick={() => dispatch(openDrawer(!drawerOpen))}
          color="inherit"
        >
          <IconMenu2 stroke={1.5} size="1.3rem" />
        </Avatar>
      </Box>
      <Box
        component="span"
        sx={{ display: { xs: "none", md: "block" }, flexGrow: 0.3 }}
      >
        <Typography variant="h2" sx={{ pl: 2.5, color: "#ffffff" }}>
          {" "}
          {ownerLabelsName
            ? ownerLabelsName.filter(
                (e) => e.key == "lbl_welcome_to_the_rental_list"
              ).length > 0
              ? ownerLabelsName.filter(
                  (e) => e.key == "lbl_welcome_to_the_rental_list"
                )[0]["value"] || "lbl_welcome_to_the_rental_list"
              : "lbl_welcome_to_the_rental_list"
            : "lbl_welcome_to_the_rental_list"}{" "}
          - {fullName}
        </Typography>
      </Box>
      <Box
        sx={{
          display: { xs: "none", sm: "block", md: "block" },
          flexGrow: 0.2,
        }}
      >
        {" "}
        <Link to={`/property/register`}>
          <Button
            sx={{
              background: "#F5D792",
              color: "#956800",

              borderRadius: "7px",
              padding: { sm: "6px 20px", xs: "4px 6px" },
              ml: { sm: "0px", xs: "5px" },
              textAlign: "center",
              "&:hover": {
                background: "#F5D792",
              },
            }}
          >
            <img src={Group232} alt="" className="pe-1" />
            {ownerLabelsName
              ? ownerLabelsName.filter((e) => e.key == "lbl_register_property")
                  .length > 0
                ? ownerLabelsName.filter((e) => e.key == "lbl_register_property")[0][
                    "value"
                  ] || "lbl_register_property"
                : "lbl_register_property"
              : "lbl_register_property"}
          </Button>
        </Link>
      </Box>
      {/* header search */}
      {/* <SearchSection /> */}
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />

      {/* mega-menu */}
      {/* <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <MegaMenuSection />
            </Box> */}

      {/* live customization & localization */}

      <Box sx={{ display: { xs: "block", sm: "block" } }}>
        <LocalizationSection />
      </Box>

      {/* notification & profile */}
      <NotificationSection />
      <ProfileSection />

      {/* mobile header */}
      <Box sx={{ display: { xs: "none", sm: "none" } }}>
        <MobileSection />
      </Box>
    </>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
});

export default connect(mapStateToProps, {})(Header);
